module.exports = __webpack_public_path__ + "img/FF_Info_Game_9.9bf868d2.png";